<template>
  <div>
    <el-container>
      <el-header>
        <div style="margin: 10px 0">
          <el-input v-model="serchat" placeholder="请输入关键字" maxlength="30" style="width: 300px;"></el-input>
          <el-date-picker
            v-model="time"
            type="daterange"
            unlink-panels
            value-format="timestamp"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions">
          </el-date-picker>
          <template>
            <el-radio v-model="radio" label="1">按销量</el-radio>
            <el-radio v-model="radio" label="2">按金额</el-radio>
          </template>
          <el-button type="primary" @click="isAjax" plain>查询</el-button>
        </div>
      </el-header>
      <el-main v-loading.fullscreen.lock="fullscreenLoading">
        <template>
          <el-table
            :data="tableData"
            stripe
            :height="divHeight"
            style="width: 100%">
            <el-table-column
              prop="_id.customerName"
              label="名称"
              width="180">
            </el-table-column>
            <el-table-column
              prop="_id.productName"
              label="商品名称"
              width="180">
            </el-table-column>
            <el-table-column
              prop="number"
              label="商品销量"
              width="120">
            </el-table-column>
            <el-table-column
              prop="productDeal"
              label="商品销售额"
              width="120">
              <template slot-scope="scope">
                <span v-html="(scope.row.productDeal).toFixed(2)+''"></span>
              </template>
            </el-table-column>
            <el-table-column
              prop="_id.productStandards"
              label="商品规格"
              width="100">
            </el-table-column>
            <el-table-column
              prop="_id.productPzwh"
              label="商品批准文号"
              width="170">
            </el-table-column>
            <el-table-column
              prop="_id.productFactory"
              label="商品厂家"
              width="180">
            </el-table-column>
            <el-table-column
              prop="_id.brand"
              label="品牌"
              width="80">
            </el-table-column>
            <el-table-column
              prop="_id.unit"
              label="单位"
              width="80">
            </el-table-column>
            <el-table-column
              prop="_id.isPrescription"
              label="是否处方药"
              width="100">
            </el-table-column>
            <el-table-column
              prop="_id.breed"
              label="经营品种"
              width="100">
            </el-table-column>
            <el-table-column
              prop="_id.dosageForm"
              label="剂型"
              width="100">
            </el-table-column>
          </el-table>
        </template>
      </el-main>
      <el-footer>
        <el-pagination
          background
          @size-change="handleSizeChange0"
          @current-change="handleCurrentChange0"
          :current-page="currentPage0"
          :page-sizes="[30, 40, 50]"
          :page-size="count0"
          layout="total, sizes, prev, pager, next, jumper"
          :total="allcount0">
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        pickerOptions: {
          shortcuts: [{
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [date, date]);
            }
          },{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        serchat: '',
        fullscreenLoading: false,
        time:[],
        tableData:[],
        allcount0:0,//总页数 对应 total
        count0:30,//一页显示多少量 对应 page-size
        currentPage0:1,//当前页数
        divHeight:500,
        radio: '1'
      }
    },
    methods:{
      formatTime:function(row, column) {
        var date = new Date(row[column.property]);
        var format = "yyyy年MM月dd日";
        var o = {
          "M+" : date.getMonth()+1, //month
          "d+" : date.getDate(),    //day
          "h+" : date.getHours(),   //hour
          "m+" : date.getMinutes(), //minute
          "s+" : date.getSeconds(), //second
          "q+" : Math.floor((date.getMonth()+3)/3),  //quarter
          "S" : date.getMilliseconds() //millisecond
        };
        if(/(y+)/.test(format)) format=format.replace(RegExp.$1,
          (date.getFullYear()+"").substr(4 - RegExp.$1.length));
        for(var k in o)if(new RegExp("("+ k +")").test(format))
          format = format.replace(RegExp.$1,
            RegExp.$1.length==1 ? o[k] :
              ("00"+ o[k]).substr((""+ o[k]).length));
        return format;
      },
      commandEvent(command) {
        this.dropdownTitle = command
      },
      handleSizeChange0(val) {
        this.count0 = val;
        this.isAjax();
      },
      handleCurrentChange0(val) {
        this.currentPage0 = val;
        this.isAjax();
      },
      isAjax:async function(){
        const h = this.$createElement;
        this.$notify({
          title: '提示',
          message: h('i', { style: 'color: red'}, '数据运算量比较大，请耐心等候。')
        });
        this.fullscreenLoading = true;
        await this.$axios.post('/data/addProductAnalysisData',{
          serchat: this.serchat,
          t:this.time,
          'radio': this.radio,
          "limit":this.count0,
          "page":this.currentPage0
        }, {timeout: 50000}).then((response,err) => {
          response = response.data;
          console.log(response)
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.tableData = response.data[0];
            this.allcount0 = response.data[1];
            this.divHeight = window.innerHeight-158;
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
          this.fullscreenLoading = false;
        }).catch(function (error) {
          this.$message.error(error);
          this.fullscreenLoading = false;
        });
      }
    },
    mounted(){
      this.isAjax();
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/dataStatistics/commodityAnalysis.vue